export function isMember(auth_user_id, resources) {
  return (
    resources?.filter(
      resource => resource?.id === auth_user_id && resource?.table === 'users'
    ).length > 0
  )
}
